var _path, _path2, _path3, _g, _path4, _path5, _path6, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9144 19.6624C11.6455 17.8299 11.8135 18.9752 10.7045 11.4165C9.19224 1.1092 24.9697 -1.25849 26.482 9.04881C27.6918 17.2946 29.2377 27.831 29.4058 28.9763",
    stroke: "#BCBBBE",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25581 28.0017C7.01529 26.3624 8.14858 24.8341 9.78709 24.5882L32.253 21.2168C33.8915 20.9709 35.4147 22.1005 35.6553 23.7398L37.6373 37.2486C38.1985 41.0736 35.5541 44.6395 31.731 45.2133L17.1765 47.3975C13.3533 47.9712 9.79904 45.3355 9.23783 41.5105L7.25581 28.0017Z",
    fill: "#FEDC33"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_72020",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 21,
    width: 32,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87548 27.9609C7.63682 26.3213 8.7714 24.7913 10.4096 24.5435L33.0113 21.1246C34.6495 20.8767 36.171 22.005 36.4097 23.6446L38.36 37.044C38.9169 40.8696 36.2695 44.4397 32.447 45.018L17.7554 47.2403C13.9329 47.8186 10.3827 45.186 9.82584 41.3603L7.87548 27.9609Z",
    fill: "#FEDC33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_72020)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.23,
    height: 23.1234,
    transform: "matrix(0.794916 -0.609003 0.598369 0.799507 3.69238 46.6907)",
    fill: "#F0C11C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3658 37.0101C26.863 36.2045 27.7726 34.5122 27.5124 32.7246C27.1818 30.4536 25.0884 28.8887 22.8366 29.2294C20.5848 29.57 19.0273 31.6872 19.3578 33.9582C19.6186 35.7499 20.9767 37.1021 22.6441 37.4258L23.2784 41.7808L26.0007 41.3693L25.3658 37.0101Z",
    fill: "#2B3035"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03226 7.66675L4.07001 9.68388L6.06451 10.7334L4.07001 11.7829L3.03226 13.8001L1.9945 11.7829L0 10.7334L1.9945 9.68388L3.03226 7.66675Z",
    fill: "#FEDC33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9678 0L45.0056 2.01713L47.0001 3.06666L45.0056 4.11619L43.9678 6.13332L42.93 4.11619L40.9355 3.06666L42.93 2.01713L43.9678 0Z",
    fill: "#FEDC33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.59541,
    cy: 1.07516,
    rx: 1.59541,
    ry: 1.07516,
    transform: "matrix(0.988926 -0.148407 0.145166 0.989407 21.8984 32.5554)",
    fill: "#3B434A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.1cbe5d56ff660fcead124dfad59508f6.svg";
export { ForwardRef as ReactComponent };